import { render, staticRenderFns } from "./ActivityLogsItem.vue?vue&type=template&id=905a3ede&scoped=true&"
import script from "./ActivityLogsItem.vue?vue&type=script&lang=js&"
export * from "./ActivityLogsItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLogsItem.vue?vue&type=style&index=0&id=905a3ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905a3ede",
  null
  
)

export default component.exports